module.exports = __webpack_public_path__ + "static/media/arcore.e609b8bd.png";